import React, {useState} from 'react';
import { connect } from 'react-redux';
import ContentArea from '@episerver/spa-core/Components/ContentArea';



function Header(props) {
  const hasEquipment = props.equipmentsTv.length > 0 || props.equipmentsInternet.length > 0;
  const hasProduct = props.haveTv || props.haveInternet;
  const showMainTitle = hasEquipment || hasProduct;

    return (
        <div className='wrapper-header'>
           {props.loginData.userDetails.firstName && <div className='title-name-login'> היי <span> {props.loginData.userDetails.firstName},</span></div>}
           {showMainTitle &&
           <div className='title-epi'>{props.epiData.mainTitle}</div>
           }
        </div>
    );
}

const mapStateToProps = (state) => {
  return {
    epiData: state.equipmentMinePage.epiData,
    loginData: state.authentication.loginData,
    equipmentsTv: state.equipmentMinePage.equipmentsTv,
    equipmentsInternet: state.equipmentMinePage.equipmentsInternet,
    haveTv: state.equipmentMinePage.haveTv,
    haveInternet: state.equipmentMinePage.haveInternet,
  };
};

const mapDispatchToProps = {

};

export default connect(mapStateToProps, mapDispatchToProps)(Header);
